import { render, staticRenderFns } from "./AdlCreate.vue?vue&type=template&id=a6554704&scoped=true&"
import script from "./AdlCreate.vue?vue&type=script&lang=ts&"
export * from "./AdlCreate.vue?vue&type=script&lang=ts&"
import style0 from "./AdlCreate.vue?vue&type=style&index=0&id=a6554704&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6554704",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VForm,VRow,VSpacer})
